import { atom } from 'jotai';

export const deviceNameAtom = atom<null | string>(null);
deviceNameAtom.debugLabel = 'My Robot/Device Name Atom';
